import React from 'react'

export const PlayIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='13.89'
		height='15.41'
		className='play-icon-svg'
		viewBox='0 0 13.885 15.41'>
		<path
			id='Path_3411'
			data-name='Path 3411'
			d='M10.623.34C9.233-.457,8.107.2,8.107,1.8V13.612c0,1.6,1.126,2.255,2.516,1.459L20.95,9.148c1.39-.8,1.39-2.089,0-2.886Z'
			transform='translate(-8.107 0)'
			fill='#3b2a82'
		/>
	</svg>
)
